import axios from 'axios';
import { supabase } from '../lib/supabaseClient';
import { redirectToLogin } from '../lib/authRedirect';

const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const API_BASE = backendUrl ? `${backendUrl}/api` : '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});
let authRecoveryInFlight = false;

api.interceptors.request.use(async (config) => {
  if (supabase) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${session.access_token}`;
      }
    } catch (e) {
      // ignore
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401 && !authRecoveryInFlight) {
      authRecoveryInFlight = true;
      try {
        if (supabase) {
          await supabase.auth.signOut();
        }
      } catch (e) {
        // Ignore cleanup failures and still return the user to login.
      } finally {
        authRecoveryInFlight = false;
      }

      await redirectToLogin('Your session has ended. Please sign in again.');
    }

    return Promise.reject(error);
  }
);

export default api;
